var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSubmenu',{staticClass:"layout-menu",attrs:{"items":_vm.model,"layoutMode":_vm.layoutMode,"menuActive":_vm.active,"root":true},on:{"menuitem-click":_vm.onMenuItemClick,"root-menuitem-click":_vm.onRootMenuItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }